import { BaseReducer } from '@identic/api';
import { DiagnosisState, DiagnosisInitialState, DiagnosisActions } from './diagnosis.state';

export function DiagnosisReducer(state: DiagnosisState = DiagnosisInitialState, action: any): DiagnosisState {
  return BaseReducer(state, action, DiagnosisActions);
}
// console.log(`%cDiagnosisReducer::ngOnInit`, 'background:yellow');
